// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__FECHL"};